export const ORGANISATION_PREFERENCES_GET = 'ORGANISATION_PREFERENCES_GET'
export const ORGANISATION_PREFERENCES_GET_SUCCESS = 'ORGANISATION_PREFERENCES_GET_SUCCESS'
export const ORGANISATION_PREFERENCES_GET_FAIL = 'ORGANISATION_PREFERENCES_GET_FAIL'
export const ORGANISATION_PREFERENCES_UPDATE = 'ORGANISATION_PREFERENCES_UPDATE'
export const ORGANISATION_PREFERENCES_UPDATE_SUCCESS = 'ORGANISATION_PREFERENCES_UPDATE_SUCCESS'
export const ORGANISATION_PREFERENCES_UPDATE_FAIL = 'ORGANISATION_PREFERENCES_UPDATE_FAIL'

export const getOrganisationPreferences = () => ({
  type: ORGANISATION_PREFERENCES_GET,
  payload: {
    request: {
      mode: 'no-cors',
      url: 'organisationpreferences',
      method: 'GET'
    }
  }
})

export const updateOrganisationPreferences = data => ({
  type: ORGANISATION_PREFERENCES_UPDATE,
  payload: {
    request: {
      mode: 'no-cors',
      url: 'organisationpreferences',
      method: 'PUT',
      data: { request: data }
    }
  }
})
